import styles from 'views/widgets/Dropdown/Dropdown.css';
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Select from 'react-select';
import classnames from 'classnames';
import 'react-select/dist/react-select.css';
import config from 'config/config_server.json';

class Dropdown extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    onChangeKey: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.object
  };

  componentDidMount () {
    this.adjustDropdownWidth(this.props.value.name);
  }

  componentDidUpdate () {
    this.adjustDropdownWidth(this.props.value.name);
  }

  adjustDropdownWidth = (label) => {
    let width;
    let rootNode = ReactDOM.findDOMNode(this.refs.select);
    if (rootNode) {
      let node = rootNode.getElementsByClassName('Select-value-label')[0];
      if (node) {
        if (label) {
          node.innerText = label;
        }
        width = node.getBoundingClientRect().width;
        rootNode.getElementsByClassName('Select-control')[0].style.width = width + 40 + 'px';
      }
    }
  }

  render () {
    let chevronIcon = `${config.editorUrl}/caret_down.svg`;
    const chevron = () => <img className={styles.caret_down} src={chevronIcon} />;
    const { disabled, onChangeKey, options, value } = this.props;
    return (
      <Select
        arrowRenderer={chevron}
        className={classnames(styles.operatorSelect, styles.select)}
        clearable={false}
        disabled={disabled || false}
        labelKey={'name'}
        multi={false}
        name="form-field-name"
        onChange={onChangeKey}
        optionClassName={styles.innerWrapper}
        options={options}
        ref='select'
        searchable={false}
        value={value}
        valueKey={'type'}
        />
    );
  }
};

export default Dropdown;



/** WEBPACK FOOTER **
 ** ./src/views/widgets/Dropdown/Dropdown.js
 **/